<template>
  <div
    class="breadcrumbs d-flex flex-row justify-content-start align-items-center"
  >
    <router-link to="" class="breadcrumb-item">
      {{ parent.label }}ss
    </router-link>

    <router-link to="" class="breadcrumb-item">
      {{ modules.label }}ss
    </router-link>
  </div>
</template>

<style scoped></style>
<script>
export default {
  name: 'breadcrumb-component',
  props: {
    parent: {
      type: Object,
      required: true,
      default: () => {}
    },

    modules: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  action: {
    type: Object,
    required: true,
    default: {}
  }
}
</script>



// WEBPACK FOOTER //
// src/base/component/breadcrumb-component.vue